import React, { useEffect, useState } from 'react';
import './styles.css';
import { Box } from '@material-ui/core';
import ImageUploaderButton from './image-uploader-button';
import ImagesUploaderList from './image-list';
import { useDataProvider } from 'react-admin';

const ImagesUploader = (props) => {
  const [images, setImages] = useState<Array<any>>([]);
  const dataProvider = useDataProvider();

  const addImages = async (files) => {
    if (files && files.length) {
      let newImages = [...images];
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        const url = URL.createObjectURL(file);
        if (url) {
          newImages.push({
            id: String(newImages.length + 1),
            url: null,
            localUrl: url,
            isUploading: true,
            file: file,
            Key: null,
          });
        }
      }
      setImages(newImages);
    }
  };
  const removeImage = async (img) => {
    if (img.error) {
      let imgs = [...images];
      imgs.splice(img.index, 1);
      setImages(imgs);
    } else {
      let response = await dataProvider.deleteBlogAssetsImage(img.Key);
      if (response.data) {
        let imgs = [...images];
        imgs.splice(img.index, 1);
        setImages(imgs);
      }
    }
  };

  async function getImages() {
    try {
      const response = await dataProvider.getBlogAssets();
      let imgs = response.data.list.map((img, index) => {
        return {
          id: img.Key,
          url: `${process.env.REACT_APP_AWS_S3_URL}/${img.Key}`,
          isUploading: false,
          Key: img.Key,
        };
      });
      setImages(imgs);
    } catch (err) {}
  }

  useEffect(() => {
    getImages();
  }, []);
  return (
    <Box className='images-uploader'>
      <Box className='images-uploader-button'>
        <ImageUploaderButton onAdd={addImages} />
      </Box>
      <Box>
        <ImagesUploaderList images={images} onRemove={removeImage} />
      </Box>
    </Box>
  );
};

export default ImagesUploader;
